module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-06-75b87161d49ae7d246591da2c3eac7a8.jpg";